<script setup></script>

<template>
	<router-view />
	<EGS_ScrollTop />
</template>
